import store from '../../state/store';
export const isCryptoCurrency = (label) => {
  const state = store.getState();
  const {
    gatewayInfo: { cryptoList = [] },
  } = state;
  const layout = state?.initTheme?.theme_editor_settings?.customization_settings?.layout;
  const isAmountFirst = layout === 'amount-first';

  if (isAmountFirst) {
    const currencies = state.profileInfo?.available_currencies?.currencies;
    const isCryptoAvailableCurrency = !!currencies?.find(
      (curr) =>
        curr.code === label && (curr.crypto === true || curr.crypto === 1 || curr.crypto === '1'),
    );
    return cryptoList.some((i) => i === label) || isCryptoAvailableCurrency;
  }

  return cryptoList.some((i) => i === label);
};
